import BaseModel from "./base/baseModel";

export default class MotivoRejeicaoModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
}
